export const normalize = (str: string): string =>
  String(str)
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
